export const deCapitalize = (str: string): string =>
  str && str.length > 0 && str[0].toLocaleLowerCase() + str.slice(1);
